import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Navbar } from "../components/Navbar";
import { Button } from "../components/ui/button";

export default function Payment() {
  const { kind } = useParams();
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState(kind === "cancel" ? "cancel" : "loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    let stop = false;

    if (kind === "paypal" || kind === "credits") {
      const orderId = params.get("token");

      if (!orderId) {
        setState("fail");
        setMsg("No se recibió la referencia del pago de PayPal.");
        return;
      }

      api.post(kind === "credits" ? "/wallet/paypal/capture" : "/payments/paypal/capture", { order_id: orderId })
        .then(() => {
          if (!stop) {
            setState("ok");
            refresh();
          }
        })
        .catch((e) => {
          if (!stop) {
            setState("fail");
            setMsg(errMsg(e));
          }
        });
    } else if (kind !== "cancel") {
      setState("fail");
      setMsg("Método de pago no disponible.");
    }

    return () => { stop = true; };
  }, [kind, params, refresh]);

  return (
    <div className="min-h-screen bg-[#09090b]" data-testid="payment-page">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-24 text-center">
        {state === "loading" && <><Loader2 className="h-10 w-10 animate-spin text-[#E8C47C] mx-auto" /><p className="mt-6 text-zinc-300" data-testid="payment-status">Confirmando tu pago…</p></>}
        {state === "ok" && <><CheckCircle2 className="h-12 w-12 text-emerald-400 mx-auto" /><h1 className="mt-6 text-2xl font-bold text-white" data-testid="payment-status">¡Pago confirmado!</h1><p className="text-zinc-400 mt-2">{kind === "credits" ? "Tu recarga ya fue acreditada a tu monedero." : "Tu plan ya está activo."}</p></>}
        {state === "fail" && <><XCircle className="h-12 w-12 text-red-400 mx-auto" /><h1 className="mt-6 text-2xl font-bold text-white" data-testid="payment-status">Pago no completado</h1><p className="text-zinc-400 mt-2">{msg}</p></>}
        {state === "cancel" && <><XCircle className="h-12 w-12 text-zinc-500 mx-auto" /><h1 className="mt-6 text-2xl font-bold text-white" data-testid="payment-status">Pago cancelado</h1><p className="text-zinc-400 mt-2">No se realizó ningún cargo.</p></>}
        {state !== "loading" && <Link to={state === "ok" ? (kind === "credits" ? "/account" : "/studio") : "/account"}><Button className="mt-8 rounded-full bg-[#E8C47C] hover:bg-[#F3D9A4] text-black font-semibold" data-testid="payment-continue-btn">{state === "ok" ? (kind === "credits" ? "Volver a mi cuenta" : "Ir al estudio") : "Volver a mi cuenta"}</Button></Link>}
      </div>
    </div>
  );
}
